import bg from "../assets/bg.png";
import chef from "../assets/chef.png";
import G from "../assets/G.png";
import fun from "../assets/fun.jpg";
import club01 from "../assets/club01.jpg";
import braai from "../assets/braai.jpg";
import fishandchips from "../assets/fishandchips.jpg";
import dance from "../assets/dance.jpg";
import burger from "../assets/burger.jpg";
import gallery01 from "../assets/gallery01.png";
import gallery02 from "../assets/gallery02.png";
import gallery03 from "../assets/gallery03.png";
import gallery04 from "../assets/gallery04.png";
import knife from "../assets/knife.png";
import forknknife from "../assets/forknknife.png";
import logo from "../assets/logo.png";
import logo01 from "../assets/logo01.png";
import menu from "../assets/menu.png";
import menu01 from "../assets/menu01.png";
import overlaybg from "../assets/overlaybg.png";
import spoon from "../assets/spoon.svg";
import welcome from "../assets/welcome.png";
import findus from "../assets/findus.png";
import laurels from "../assets/laurels.png";
import award01 from "../assets/award01.png";
import award02 from "../assets/award01.png";
import award03 from "../assets/award01.png";
import award05 from "../assets/award01.png";
import sign from "../assets/sign.png";
import signature from "../assets/signature.png";
import quote from "../assets/quote.png";
import gericht from "../assets/gericht.png";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  bg,
  chef,
  G,
  fun,
  club01,
  braai,
  fishandchips,
  burger,
  dance,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  knife,
  forknknife,
  logo,
  logo01,
  menu,
  menu01,
  overlaybg,
  spoon,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  signature,
  quote,
  gericht,
};
